import { useKycVerificationContext } from "../../Contexts/KycVerificationContext";
import CustomizedProgressBars from "../../Components/LinearDeterminate";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import { ScrollBar } from "../../Components/ScrollBar";
import { CircularProgress } from "@mui/material";
import Button from "../../Components/Button";
import PersonalInfo from "./PersonalInfo";
import CaptureSelf from "./CaptureSelf";
import CancelModal from "./CancelModal";
import UnderReview from "./UnderReview";
import CaptureId from "./CaptureId";
import IdType from "./IdType";
import Review from "./Review";
import React from "react";

import { baseUrl } from "../../utilities/configurations";
import axios from "axios";
import { useAuth } from "../../Contexts/AuthContext";

function Process() {
  const { token } = useAuth();
  const {
    formData,
    setCurrentStep,
    isTncAccepted,
    setModalShown,
    setLoadState,
    currentStep,
    modalShown,
    loadState,
    navigate,
  } = useKycVerificationContext();

  const { memberStatus } = useAuth();

  const calculateProgress = () => {
    let totalStep = 5;
    return (currentStep / totalStep) * 100;
  };

  const handleNext = async () => {
    if (currentStep === 1) {
      setCurrentStep(currentStep + 1);
    } else if (currentStep === 2) {
      setCurrentStep(currentStep + 1);
    } else if (currentStep === 3) {
      setLoadState("confirming");
      try {
        const res = await axios.post(
          baseUrl + "/KYC/information",
          {
            imageFront: formData.frontID.split(",")[1],
            imageBack: formData.backID.split(",")[1],
            selfie: formData.selfie.split(",")[1],
            serviceID: formData.selectedID?.id,
          },
          {
            headers: {
              "content-type": "application/json",
              Authorization: `Bearer ${token.accessToken}`,
            },
          }
        );

        if (
          res.data.status &&
          res.data.message === "KYC Information retrieved successfully."
        ) {
          setLoadState("");
          setCurrentStep(currentStep + 1);
        } else {
          setLoadState("");
        }
      } catch (error) {
        setLoadState("");
        console.log(error);
      }
    } else if (currentStep === 4) {
      setCurrentStep(currentStep + 1);
    } else if (currentStep === 5) {
      handleVerify();
    }
  };

  const renderMothersName = () => {
    let fname = formData.mothersFirstName || "";
    let mname = formData.mothersMiddleName || "";
    let lname = formData.mothersLastName || "";

    let fullName =
      (fname ? fname + " " : "") +
      (mname ? mname + " " : "") +
      (lname ? lname : "");

    return fullName;
  };

  const renderAddress = () => {
    let address1 = formData.bldgName || "";
    let address2 = formData.street || "";
    let address3 = formData.subdivision || "";
    let address4 = formData.city || "";
    let address5 = formData.state || "";
    let address6 = formData.areaCode || "";
    let address7 = formData.zipCode || "";

    let address =
      (address1 ? address1 + " " : "") +
      (address2 ? address2 + " " : "") +
      (address3 ? address3 + " " : "") +
      (address4 ? address4 + " " : "") +
      (address5 ? address5 + " " : "") +
      (address6 ? address6 + " " : "") +
      (address7 ? address7 : "");

    return address;
  };

  const handleVerify = async () => {
    setLoadState("verify");
    if (memberStatus.kycStatus === "") {
      try {
        const submit = await axios.post(
          baseUrl + "/KYC/confirm",
          {
            cardNumber: formData.cardNumber.replaceAll(" ", ""),
            firstName: formData.firstName,
            middleName: formData.middleName,
            lastName: formData.lastName,
            suffix: formData.suffix,
            gender: formData.gender,
            dateofBirth: formData.dateOfBirth,
            validIDNumber: formData.idNumber,
            mobileNumber: formData.mobileNumber,
            email: formData.emailAddress,
            nationality: formData.nationality,
            placeOfBirth: formData.placeOfBirth,
            fullAddress: renderAddress(),
            mothersMaidenName: renderMothersName(),
            companyName: formData.companyName,
            imageFront: formData.frontID.split(",")[1],
            imageBack: formData.backID.split(",")[1],
            signature: formData.signature?.file.split(",")[1],
            selfie: formData.selfie.split(",")[1],
          },
          {
            headers: {
              "content-type": "application/json",
              Authorization: `Bearer ${token.accessToken}`,
            },
          }
        );
        if (
          submit.data.status &&
          (submit.data.message === "KYC is under review" ||
            submit.data.message === "KYC successfully verified.")
        ) {
          setLoadState("verify success");
        } else {
          setLoadState("");
        }
      } catch (error) {
        setLoadState("");
        console.log(error);
      }
    } else {
      try {
        const submit = await axios.post(
          baseUrl + "/KYC/Update-Information",
          {
            id: `${memberStatus.kycId}`,
            fullAddress: renderAddress(),
            imageFront: formData.frontID.split(",")[1],
            imageBack: formData.backID.split(",")[1],
            signature: formData.signature?.file.split(",")[1],
            selfie: formData.selfie.split(",")[1],
          },
          {
            headers: {
              "content-type": "application/json",
              Authorization: `Bearer ${token.accessToken}`,
            },
          }
        );
        if (
          submit.data.status &&
          submit.data.message === "KYC Information successfully updated"
        ) {
          setLoadState("verify success");
        } else {
          setLoadState("");
        }
      } catch (error) {
        setLoadState("");
        console.log(error);
      }
    }
  };

  const handlePrev = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleBackToDashboard = () => {
    setLoadState("");
    navigate("/home", { replace: true });
  };

  const handleCloseVerification = () => {
    setModalShown(true);
  };

  let closeButton = (
    <button onClick={handleCloseVerification}>
      <CloseOutlinedIcon />
    </button>
  );

  let backButton = (
    <button disabled>
      <KeyboardArrowLeft className="invisible" />
    </button>
  );

  if (currentStep >= 2 && currentStep <= 5) {
    backButton = (
      <button onClick={handlePrev}>
        <KeyboardArrowLeft />
      </button>
    );
  }

  let buttonTxt = "Continue";

  if (currentStep >= 5) {
    buttonTxt = "Confirm";
  }

  let isButtonDisabled = true;

  // Additional conditions for specific steps
  if (currentStep === 1) {
    isButtonDisabled = formData.selfie === "";
  } else if (currentStep === 2) {
    isButtonDisabled = formData.selectedID === undefined;
  } else if (currentStep === 3) {
    isButtonDisabled =
      formData.frontID === "" ||
      formData.backID === "" ||
      loadState === "confirming";
  } else if (currentStep === 4 || currentStep === 5) {
    const requiredFields = [
      formData.cardNumber,
      formData.firstName,
      formData.lastName,
      formData.gender,
      formData.idNumber,
      formData.selectedID,
      formData.mobileNumber,
      formData.emailAddress,
      formData.nationality,
      formData.placeOfBirth,
      formData.dateOfBirth,
      formData.street,
      formData.city,
      formData.state,
      formData.zipCode,
      formData.mothersFirstName,
      formData.mothersMiddleName,
      formData.mothersLastName,
      formData.companyName,
      formData.signature,
    ];

    const allFieldsFilled = requiredFields.every(
      (field) => field !== "" && field !== undefined
    );

    isButtonDisabled =
      !allFieldsFilled || !isTncAccepted || loadState === "verify";
  }

  let nextButton = (
    <Button
      disabled={isButtonDisabled}
      className={`h-12 w-full transition ease-in-out delay-75 rounded-xl
                ${
                  isButtonDisabled
                    ? "bg-[#F6F7F7] text-gray-400"
                    : "bg-[#0947AB] text-white"
                }`}
      onClick={handleNext}
    >
      {loadState === "verify" || loadState === "confirming" ? (
        <CircularProgress size={"1rem"} />
      ) : (
        buttonTxt
      )}
    </Button>
  );

  let content = null;
  if (currentStep === 1) {
    content = <CaptureSelf />;
  } else if (currentStep === 2) {
    content = <IdType />;
  } else if (currentStep === 3) {
    content = <CaptureId />;
  } else if (currentStep === 4) {
    content = <PersonalInfo />;
  } else if (currentStep === 5) {
    content = <Review />;
  }

  if (loadState === "verify success") {
    closeButton = null;
    backButton = null;

    nextButton = (
      <Button
        className={`h-12 w-full transition ease-in-out delay-75 rounded-xl bg-[#0947AB] text-white`}
        onClick={handleBackToDashboard}
      >
        Go back to dashboard
      </Button>
    );

    content = <UnderReview />;
  }

  return (
    <div className="flex flex-col min-h-screen sm:items-center sm:bg-[#E7EEFA]">
      <div className="flex flex-col flex-1 sm:flex-none bg-white sm:w-148 sm:items-center rounded-xl sm:my-24">
        <div className="w-full">
          <div className="flex flex-row p-3 border-b">
            {backButton}
            <div className="text-center text-md font-bold flex-1">
              Verification
            </div>
            {closeButton}
          </div>
          <div className="p-3">
            <CustomizedProgressBars
              className={currentStep >= 5 ? "invisible" : ""}
              value={calculateProgress()}
            />
          </div>
        </div>
        <ScrollArea.Root className="w-full rounded overflow-hidden">
          <ScrollArea.Viewport
            id="scrollDiv"
            style={{ scrollBehavior: "smooth" }}
            className="w-full min-h-[200px] h-[calc(100vh-165px)] sm:h-full rounded"
          >
            {content}
          </ScrollArea.Viewport>
          <ScrollBar />
        </ScrollArea.Root>
        <div className="flex w-full p-4 mt-auto">{nextButton}</div>
      </div>
      <CancelModal
        open={modalShown}
        onClose={() => setModalShown(false)}
        onCancel={() => navigate(-1)}
      />
    </div>
  );
}

export default Process;
